var CoreJoystick = /** @class */ (function () {
    function CoreJoystick(scene, x, y, size) {
        this.scene = scene;
        this.position = {
            x: x,
            y: y,
        };
        this.plugin = this.scene.plugins.get("rexvirtualjoystickplugin");
        // @ts-ignore
        this.joystick = this.plugin.add(this, {
            x: this.position.x,
            y: this.position.y,
            radius: size.radius,
            base: this.scene.add
                .image(0, 0, "joystick_base")
                .setDisplaySize(size.base.width, size.base.height)
                .setSize(size.base.width, size.base.height),
            thumb: this.scene.add
                .image(0, 0, "joystick_thumb")
                .setDisplaySize(size.thumb.width, size.thumb.height),
            // dir: "8dir",
            // forceMin: 16,
            fixed: true,
            // enable: true
        });
        this.joystick.base.setDepth(999998);
        this.joystick.thumb.setDepth(999999);
    }
    CoreJoystick.prototype.on = function (event, listener) {
        this.joystick.on(event, listener);
    };
    CoreJoystick.prototype.onMove = function (listener) {
        var _this = this;
        this.on("update", function () {
            if (_this.joystick.thumb.x === _this.position.x &&
                _this.joystick.thumb.y === _this.position.y)
                return;
            listener(_this.joystick.thumb.x, _this.joystick.thumb.y, Phaser.Math.Angle.Between(_this.position.x, _this.position.y, _this.joystick.thumb.x, _this.joystick.thumb.y) -
                Math.PI / 2);
        });
    };
    CoreJoystick.prototype.setPosition = function (x, y) {
        // @ts-ignore
        this.joystick.setPosition(x, y);
        this.position = { x: x, y: y };
    };
    CoreJoystick.prototype.setVisible = function (visible) {
        this.joystick.visible = visible;
    };
    CoreJoystick.prototype.setScale = function (x, y) {
        this.joystick.base.setScale(x, y);
        this.joystick.thumb.setScale(x, y);
    };
    return CoreJoystick;
}());
export default CoreJoystick;
